exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Animation */\n@keyframes placeHolderShimmer{\n    0%{\n        background-position: -468px 0\n    }\n    100%{\n        background-position: 468px 0\n    }\n}\n\n.placeload-background {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: placeHolderShimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n    background-size: 1000px 104px;\n    height: 0;\n    position: relative;\n    overflow: hidden;\n}\n.placeload-masker {\n    background: #fff;\n    position: absolute;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./lib/style.css
// module id = 25
// module chunks = 0